import "src/decidim/cas_client/box_visiblity.js";

// Images
require.context("../images", true)

// CSS
import "entrypoints/decidim_cas_client.scss";